import React, { Fragment, useMemo } from "react";
import { Formik, FormikProps } from "formik";
import * as Yup from "yup";
import { wire } from "react-hot-wire";
import { WithTranslation, withTranslation } from "react-i18next";
import Button from "@material-ui/core/Button";

import { SiteService } from "services/site/Site.service";
import { Application } from "models/application/Application";
import Dialog from "components/common/dialog/Dialog";
import Erase from "./Erase.template";

export type AddUserFormValues = {
  appName: string;
  removeFromList: boolean;
  removeJobsAndDeployments: boolean;
};

const createAddUserSchema = (appName: string) =>
  Yup.object().shape({
    appName: Yup.string()
      .required()
      .matches(new RegExp(`^${appName}$`)),
    removeFromList: Yup.boolean(),
    removeJobsAndDeployments: Yup.boolean()
  });

function EraseComponent({
  application,
  siteService,
  t
}: {
  application: Application;
  siteService: SiteService;
} & WithTranslation) {
  const addUserSchema = useMemo(() => createAddUserSchema(application.name), [
    application.name
  ]);

  return (
    <Dialog
      render={({ close }) => (
        <Fragment>
          <div className="modal-header flex flex-column">
            <h5 className="modal-title disable-select">
              {t("application.erase.title", {
                application
              })}
            </h5>
            <div>
              <small>
                {t("application.erase.note", {
                  application
                })}
              </small>
            </div>
          </div>
          <Formik
            initialValues={{
              appName: "",
              removeFromList: true,
              removeJobsAndDeployments: true
            }}
            validationSchema={addUserSchema}
            onSubmit={() => {}}
            render={(props: FormikProps<AddUserFormValues>) => (
              <Fragment>
                <Erase formikProps={props} />
                <div className="modal-footer">
                  <Button
                    color="secondary"
                    variant="contained"
                    className="p-2"
                    size="small"
                    onClick={close}
                  >
                    {t("application.deploy.cancelButton")}
                  </Button>
                  <Button
                    color="default"
                    variant="contained"
                    className="p-2"
                    size="small"
                    disabled={!props.isValid || props.isSubmitting}
                    onClick={() =>
                      siteService
                        .eraseApplication({
                          application,
                          options: {
                            removeFromList: props.values.removeFromList,
                            removeJobsAndDeployments:
                              props.values.removeJobsAndDeployments
                          }
                        })
                        .then(close)
                    }
                  >
                    {t("application.erase.eraseButton")}
                  </Button>
                </div>
              </Fragment>
            )}
          />
        </Fragment>
      )}
    />
  );
}

export default wire(["siteService"], withTranslation()(EraseComponent));
